export const stadtteile = [
  { name: 'Aplerbeck', slug: 'aplerbeck', plz: ['44287'] },
  { name: 'Berghofen', slug: 'berghofen', plz: ['44287', '44265'] },
  { name: 'Schüren', slug: 'schueren', plz: ['44265'] },
  { name: 'Sölde', slug: 'soelde', plz: ['44319'] },
  { name: 'Loh', slug: 'loh', plz: ['44287'] },
  { name: 'Eving', slug: 'eving', plz: ['44339', '44369', '44388', '44534'] },
  { name: 'Brechten', slug: 'brechten', plz: ['44329'] },
  { name: 'Holthausen', slug: 'holthausen', plz: ['44329'] },
  { name: 'Kemminghausen', slug: 'kemminghausen', plz: ['44339'] },
  { name: 'Lindenhorst', slug: 'lindenhorst', plz: ['44339'] },
  { name: 'Hombruch', slug: 'hombruch', plz: ['44225', '44227'] },
  { name: 'Kirchhörde', slug: 'kirchhoerde', plz: ['44225'] },
  { name: 'Lücklemberg', slug: 'luecklemberg', plz: ['44225'] },
  { name: 'Barop', slug: 'barop', plz: ['44225'] },
  { name: 'Menglinghausen', slug: 'menglinghausen', plz: ['44227'] },
  { name: 'Hörde', slug: 'hoerde', plz: ['44263', '44265'] },
  { name: 'Benninghofen', slug: 'benninghofen', plz: ['44267'] },
  { name: 'Syburg', slug: 'syburg', plz: ['44265', '58456'] },
  { name: 'Wellinghofen', slug: 'wellinghofen', plz: ['44265', '44267'] },
  { name: 'Huckarde', slug: 'huckarde', plz: ['44369'] },
  { name: 'Rahm', slug: 'rahm', plz: ['44369'] },
  { name: 'Wischlingen', slug: 'wischlingen', plz: ['44369'] },
  { name: 'Kirchlinde', slug: 'kirchlinde', plz: ['44379'] },
  { name: 'Hafen', slug: 'hafen', plz: ['44147'] },
  { name: 'Nordmarkt', slug: 'nordmarkt', plz: ['44145', '44147'] },
  { name: 'Scharnhorst', slug: 'scharnhorst', plz: ['44145'] },
  { name: 'Mitte-Ost', slug: 'mitte-ost', plz: ['44135', '44137', '44141', '44143'] },
  { name: 'Körne', slug: 'koerne', plz: ['44143'] },
  { name: 'Westfalenhütte', slug: 'westfalenhuette', plz: ['44141'] },
  { name: 'Mitte-West', slug: 'mitte-west', plz: ['44135', '44137', '44139'] },
  { name: 'Dorstfeld', slug: 'dorstfeld', plz: ['44149'] },
  { name: 'Kreuzviertel', slug: 'kreuzviertel', plz: ['44139'] },
  { name: 'Lütgendortmund', slug: 'luetgendortmund', plz: ['44388'] },
  { name: 'Bövinghausen', slug: 'boevinghausen', plz: ['44388'] },
  { name: 'Marten', slug: 'marten', plz: ['44379'] },
  { name: 'Oespel', slug: 'oespel', plz: ['44149'] },
  { name: 'Mengede', slug: 'mengede', plz: ['44357'] },
  { name: 'Bodelschwingh', slug: 'bodelschwingh', plz: ['44357'] },
  { name: 'Groppenbruch', slug: 'groppenbruch', plz: ['44536'] },
  { name: 'Nette', slug: 'nette', plz: ['44359'] },
  { name: 'Oestrich', slug: 'oestrich', plz: ['44357'] },
  { name: 'Scharnhorst', slug: 'scharnhorst-scharnhorst', plz: ['44328', '44329'] },
  { name: 'Alt-Scharnhorst', slug: 'alt-scharnhorst', plz: ['44328'] },
  { name: 'Derne', slug: 'derne', plz: ['44329'] },
  { name: 'Grevel', slug: 'grevel', plz: ['44329', '44339'] },
  { name: 'Lanstrop', slug: 'lanstrop', plz: ['44328'] },
  { name: 'Brackel', slug: 'brackel', plz: ['44309'] },
  { name: 'Asseln', slug: 'asseln', plz: ['44319'] },
  { name: 'Wambel', slug: 'wambel', plz: ['44143'] },
  { name: 'Wickede', slug: 'wickede', plz: ['44319'] }
];

export const ratgeber = [
  { 
    title: 'Schließzylinder ausmessen', 
    slug: 'schliesszylinder-ausmessen',
    excerpt: 'So messen Sie Ihren Schließzylinder korrekt aus – Schritt-für-Schritt Anleitung mit Tipps.' 
  },
  { 
    title: 'Türschloss wechseln', 
    slug: 'tuerschloss-wechseln',
    excerpt: 'Anleitung zum fachgerechten Wechsel Ihres Türschlosses – Was Sie beachten müssen.' 
  },
  { 
    title: 'DIN rechts & DIN links', 
    slug: 'din-rechts-din-links',
    excerpt: 'Den Unterschied zwischen DIN rechts und DIN links verstehen – Einfach erklärt.' 
  },
  { 
    title: 'Schlüssel abgebrochen', 
    slug: 'schluessel-abgebrochen',
    excerpt: 'Was tun, wenn der Schlüssel im Schloss abbricht? Erste Hilfe und professionelle Lösungen.' 
  },
  { 
    title: 'Tür zugefallen', 
    slug: 'tuer-zugefallen',
    excerpt: 'Tür zugefallen und kein Schlüssel dabei? So handeln Sie richtig in dieser Situation.' 
  },
  { 
    title: 'Einbruchschutz für Türen', 
    slug: 'einbruchschutz-tueren',
    excerpt: 'Effektiver Einbruchschutz für Ihre Haustür – Moderne Sicherheitstechnik im Überblick.' 
  },
  { 
    title: 'Sicherheitszylinder', 
    slug: 'sicherheitszylinder',
    excerpt: 'Sicherheitszylinder: Schutz vor Einbruch und Manipula tion – Welche Normen sind wichtig?' 
  },
  { 
    title: 'Mehrfachverriegelung', 
    slug: 'mehrfachverriegelung',
    excerpt: 'Mehrfachverriegelungen erhöhen die Sicherheit deutlich – Funktionsweise und Vorteile.' 
  },
  { 
    title: 'Tresor öffnen', 
    slug: 'tresor-oeffnen',
    excerpt: 'Tresor lässt sich nicht öffnen? Professionelle Hilfe ohne Beschädigung des Inhalts.' 
  },
  { 
    title: 'Schonende Türöffnung', 
    slug: 'schonende-tueroeffnung',
    excerpt: 'Beschädigungsfreie Türöffnung durch Fachleute – Methoden und Techniken im Detail.' 
  }
];
